var render = function render(){var _vm=this,_c=_vm._self._c;return _c('list-dashboards',{attrs:{"titleSmartsheet":"Comercial Industrial","typeSmartsheet":_vm.SMARTSHEET_TYPES.industrial_commercial}})
}
var staticRenderFns = []

export { render, staticRenderFns }